import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_PINNED_UNITS_LIST = () => ['getDashPinnedList']

export const getDashPinnedList = async (): Promise<IPortalUnitSearchModel[]> =>
  axios.get(`/dashwidget/getpinnedunits`).then((res) => res.data?.data)

type QueryFnType = typeof getDashPinnedList

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetDashPinnedList = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_PINNED_UNITS_LIST(),
    queryFn: () => getDashPinnedList()
  })
